const dev = {
  API_URL: 'https://staging.admin.citizenmusic.com/wp-json',
};

const prod = {
  API_URL: 'https://admin.citizenmusic.com/wp-json',
};

const config = process.env.REACT_APP_STAGE === 'production'
  ? prod
  : dev;

export default config;


// WEBPACK FOOTER //
// ./src/config.js